// Top-level routing for the klonit-admin SPA.
//
//   /login                       -> public Login page
//   /dashboard       (auth)      -> Phase D landing page: 6 summary widgets
//   /users           (auth)      -> Users list
//   /users/:userId   (auth)      -> User detail (subscription + invoices + Pay)
//   /users/pending-verifications -> Phase D detail page
//   /users/by-chatbots           -> Phase D detail page (ranked by chatbots)
//   /chatbot-history             -> Phase D detail page (user-wise + chatbot-wise tabs)
//   /plans           (auth)      -> Plans CRUD (Phase C)
//   /invoices/pending (auth)     -> Pending invoices across all users (kept
//                                   routed; dashboard widget links here)
//   /                (auth)      -> redirect to /dashboard
//   *                            -> redirect to /dashboard
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import RequireAuth from './components/RequireAuth';
import AppShell from './components/AppShell';
import Login from './pages/Login';
import Users from './pages/Users';
import UserDetail from './pages/UserDetail';
import PendingInvoices from './pages/PendingInvoices';
import Plans from './pages/Plans';
import Dashboard from './pages/Dashboard';
import PendingVerifications from './pages/PendingVerifications';
import UserChatbots from './pages/UserChatbots';
import ChatbotHistory from './pages/ChatbotHistory';
import Analytics from './pages/Analytics';

const App = () => (
    <BrowserRouter>
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<RequireAuth><AppShell /></RequireAuth>}>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/users" element={<Users />} />
                <Route path="/users/pending-verifications" element={<PendingVerifications />} />
                <Route path="/users/by-chatbots" element={<UserChatbots />} />
                <Route path="/users/:userId" element={<UserDetail />} />
                <Route path="/chatbot-history" element={<ChatbotHistory />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/plans" element={<Plans />} />
                <Route path="/invoices/pending" element={<PendingInvoices />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Route>
        </Routes>
    </BrowserRouter>
);

export default App;
